<template>
  <div class="notification-settings v-notification-settings">
    <div class="pa-24 dash">
      <div class="el-text--size-m">
        {{ $t('Notification settings') }}
      </div>
      <el-switch
        v-model="mutedAll"
        class="mt-24"
      >
        <span class="el-text--strong">{{ $t('Do not disturb') }}</span>
      </el-switch>
      <div class="mt-8 el-text--size-xs">
        {{ $t('Mutes all pop-up notifications. Notifications will still be available in the notification center.') }}
      </div>
    </div>
    <div class="pa-24">
      <div class="el-text--strong">
        {{ $t('Allow pop-up notifications') }}
      </div>
      <div class="el-text--size-xs">
        {{ $t('Select which notification types will be shown as pop-up messages.') }}
      </div>
      <div class="mt-16">
        <el-checkbox
          v-model="mutedError"
          type="checkbox"
          :true-label="0"
          :false-label="1"
          :disabled="mutedAll"
        >
          {{ NOTIFICATION_TYPE_LABELS[NotificationType.ERROR] }}
        </el-checkbox>
      </div>
      <div>
        <el-checkbox
          v-model="mutedInfo"
          :true-label="0"
          :false-label="1"
          :disabled="mutedAll"
        >
          {{ NOTIFICATION_TYPE_LABELS[NotificationType.INFO] }}
        </el-checkbox>
      </div>
      <div>
        <el-checkbox
          v-model="mutedSuccess"
          :true-label="0"
          :false-label="1"
          :disabled="mutedAll"
        >
          {{ NOTIFICATION_TYPE_LABELS[NotificationType.SUCCESS] }}
        </el-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    NotificationType,
    NOTIFICATION_CENTER_FILTER_TYPES,
    NOTIFICATION_TYPE_LABELS
  } from '@/common/constants/notifications.constants';
  import { mapState } from 'pinia';
  import { useNotificationsStore } from '@/common/store/pinia/notifications';
  import { capitalize } from 'lodash-es';

  export default {
    name: 'NotificationSettings',
    setup() {
      const notificationsStore = useNotificationsStore();
      return { notificationsStore };
    },
    data() {
      return {
        NotificationType,
        NOTIFICATION_TYPE_LABELS,
      };
    },
    computed: {
      ...mapState(useNotificationsStore, {
        notifications: 'state'
      }),
      ...NOTIFICATION_CENTER_FILTER_TYPES.reduce((acc, type) => {
        acc[`muted${capitalize(type)}`] = {
          get() {
            return type === NotificationType.ALL ? this.notifications.muted[type] : Number(this.notifications.muted[type]);
          },
          set(value) {
            this.notificationsStore.mute({ [type]: Boolean(value) });
          }
        };
        return acc;
      }, {})
    }
  };
</script>

<style lang="scss" scoped>
.dash {
  box-shadow: 0 -1px 0 0 $av-brand-accent inset;
}
</style>
